/**
 * List Schema of WebserviceIntegracao
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {WebserviceIntegracao} from '@/model/resource/WebserviceIntegracao'

/* TODO: review generated schema */
export class ListWebserviceIntegracaoSchema extends Schema {
  readonly name = 'ListWebserviceIntegracao'

  readonly fieldSet: FieldSet<WebserviceIntegracao> = {
    path: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
